import React, { useState, useCallback } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { trackEnGaPageView } from '../utils/enGa'
import { syncSiteSeoHead } from '../utils/siteSeo'
import Header from './Header'
import Footer from './Footer'
import IntroAnimation from './IntroAnimation'
import BackgroundElements from './BackgroundElements'
import ScrollToTopButton from './ScrollToTopButton'

const ScrollToTop = () => {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '')
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname, hash])
  return null
}

const Layout = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const path = location.pathname + location.search
    trackEnGaPageView(path)
  }, [location.pathname, location.search])

  useEffect(() => {
    syncSiteSeoHead()
  }, [location.pathname, location.search])

  const [showIntro, setShowIntro] = useState(() => {
    if (typeof window === 'undefined') return false
    if (window.location.pathname !== '/') return false
    const params = new URLSearchParams(window.location.search)
    if (params.get('skipIntro') === '1') {
      sessionStorage.setItem('algomori-intro-shown', 'true')
      return false
    }
    return sessionStorage.getItem('algomori-intro-shown') !== 'true'
  })

  useEffect(() => {
    if (location.pathname !== '/') return
    const params = new URLSearchParams(location.search)
    if (params.get('skipIntro') !== '1') return
    params.delete('skipIntro')
    const nextSearch = params.toString()
    navigate({ pathname: '/', search: nextSearch ? `?${nextSearch}` : '' }, { replace: true })
  }, [location.pathname, location.search, navigate])

  const handleIntroComplete = useCallback(() => {
    setShowIntro(false)
  }, [])

  // Called when logo is clicked — replays the cinematic intro
  const handleLogoClick = useCallback(() => {
    sessionStorage.removeItem('algomori-intro-shown')
    setShowIntro(true)
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="text-text-main overflow-x-hidden min-h-screen flex flex-col">
      <ScrollToTop />
      {showIntro && (
        <IntroAnimation onComplete={handleIntroComplete} />
      )}
      <BackgroundElements />
      <Header onLogoClick={handleLogoClick} />
      <main className="flex-1">
        <Outlet />
      </main>
      <ScrollToTopButton />
      <Footer />
    </div>
  )
}

export default Layout